module.exports = __webpack_public_path__ + "f65e425afa1d337f3d7bad202c996ee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/create_workshop_info/top_background@2x.jpg
// module id = 650
// module chunks = 0